import React from "react";
const RespondStickyIcon = ({
  ...rest
}) => {
  return /*#__PURE__*/React.createElement("svg", {
    width: "50",
    height: "50",
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "22",
    r: "22",
    fill: "#EC6884"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 18H21C19.3 18 18 19.3 18 21V26.3C18 28 19.3 29.3 21 29.3H27.9L30.3 31.7C30.7 32.1 31.3 32.1 31.7 31.7C31.9 31.5 32 31.3 32 31V21C32 19.3 30.7 18 29 18ZM28 16.5V15C28 13.3 26.7 12 25 12H15C13.3 12 12 13.3 12 15V27C12 27.6 12.4 28 13 28C13.3 28 13.5 27.9 13.7 27.7L16.5 24.9V21C16.5 18.5 18.5 16.5 21 16.5H28Z",
    fill: "white"
  }));
};
export default RespondStickyIcon;